import Color from 'color'
import { logoutBegin } from 'data/auth/actions'
import AccountIcon from 'mdi-react/AccountIcon'
import AccountTieIcon from 'mdi-react/AccountTieIcon'
import BadgeAccountHorizontalIcon from 'mdi-react/BadgeAccountHorizontalIcon'
import BinocularsIcon from 'mdi-react/BinocularsIcon'
import DomainIcon from 'mdi-react/DomainIcon'
import LogoutIcon from 'mdi-react/LogoutIcon'
import MagnifyIcon from 'mdi-react/MagnifyIcon'
import React from 'react'
import { useDispatch } from 'react-redux'
import { DEAL_MANAGER_PATH, LOGOUT_PATH, ORGANIZATION_MANAGER_PATH } from 'scenes/Dashboard/Dashboard.routes'
import { SEARCH_ENGINE_PATH } from 'scenes/Dashboard/scenes/SearchEngine/SearchEngine.routes'
import { USER_MANAGER_PATH } from 'scenes/Dashboard/scenes/UsersManager'
import { makeStyles } from 'tss-react/mui'
import { useLocation } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { Divider, Theme } from '@mui/material'

import { CORPORATE_MANAGER_PATH } from '../../scenes/CorporateManager'
import { SCOUTING_CAMPAIGN_MANAGER_PATH } from '../../scenes/ScoutingCampaignManager'
import Navigation, { NavigationElement } from './components/Navigation'
import UserHeader from './components/UserHeader'

export type SidebarContentProps = ExtendableStyles & Testable

export function SidebarContent({ className, ...otherProps }: SidebarContentProps) {
  const { currentPath, mainNavigation, otherNavigation } = useSidebarRoutes()
  const { classes, cx } = useStyles()
  return (
    <div className={cx(className, classes.sidebarContainer)} {...otherProps}>
      <UserHeader />
      <Divider classes={{ root: classes.divider }} />
      <div className={classes.routes}>
        <Navigation currentPath={currentPath} elements={mainNavigation} />
        <Navigation currentPath={currentPath} elements={otherNavigation} />
      </div>
    </div>
  )
}

const foundernestPrivateRoutes: NavigationElement[] = [
  {
    path: DEAL_MANAGER_PATH,
    label: 'Pairings',
    icon: BadgeAccountHorizontalIcon,
  },
  {
    path: SCOUTING_CAMPAIGN_MANAGER_PATH,
    label: 'Spaces',
    icon: BinocularsIcon,
  },
  {
    path: USER_MANAGER_PATH,
    label: 'Users',
    icon: AccountIcon,
  },
  {
    path: CORPORATE_MANAGER_PATH,
    label: 'Corporates',
    icon: AccountTieIcon,
  },
  {
    path: ORGANIZATION_MANAGER_PATH,
    label: 'Organizations',
    icon: DomainIcon,
  },
  {
    path: SEARCH_ENGINE_PATH,
    label: 'Search Engine',
    icon: MagnifyIcon,
  },
]

function useSidebarRoutes() {
  const dispatch = useDispatch()
  const { pathname: currentPath } = useLocation()
  const otherNavigation: NavigationElement[] = [
    {
      path: LOGOUT_PATH,
      label: 'Logout',
      icon: LogoutIcon,
      onClick: () => dispatch(logoutBegin()),
    },
  ]

  return {
    currentPath,
    mainNavigation: foundernestPrivateRoutes,
    otherNavigation,
  }
}

const useStyles = makeStyles()(({ palette }: Theme) => ({
  sidebarContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
  },
  divider: {
    backgroundColor: Color(palette.primary.contrastText).alpha(0.12).string(),
  },
  routes: {
    display: 'flex',
    flexDirection: 'column',
  },
}))
